import { render, staticRenderFns } from "./mock-panel.vue?vue&type=template&id=4444e6c8&"
import script from "./mock-panel.vue?vue&type=script&lang=js&"
export * from "./mock-panel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports